import { asyncScheduler, NEVER, pipe } from "rxjs";
import { debounceTime, distinctUntilChanged, map, skip, switchMap, takeUntil } from "rxjs/operators";
export const AUTOCOMPLETE = 'autocomplete';
/**
 * debounce filter long requests
 * inspired by https://blog.strongbrew.io/building-a-safe-autocomplete-operator-with-rxjs/
 * @param debounce debounce timing
 * @param selector filter request
 */
export const autocomplete = (debounce, selector) => (source$) => source$.pipe(debounceTime(debounce), switchMap((...args) => Boolean(selector) ? selector(...args).pipe(takeUntil(source$.pipe(skip(1)))) : NEVER));
/**
 * Autocomplite filter plain sync function
 * @param debounce debounce time
 * @param scheduler SchedulerLike
 */
export const filterWithDebounce = (debounce, scheduler = asyncScheduler) => (filterFun) => {
  return pipe(debounceTime(debounce, scheduler), distinctUntilChanged(), map((search) => filterFun(search)));
};
/**
 * Functions splits array in two
 * @param list original list of items
 * @param filter function
 */
export const arraySplitter = (list, filter) => {
  return list.reduce((acc, value, idx) => {
    //target of splitting: if filter true index 0 else 1
    acc[filter(value, idx) ? 0 : 1].push(value);
    return acc;
  }, [[], []]);
};
//# sourceMappingURL=utils.js.map
